import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SiteLayout, PageHeader } from "../layouts/SiteLayout";
import { PROJECTS } from "../data/siteContent";
import { PROJECTS_T } from "../constants/siteTestIds";
import { Seo } from "../seo/Seo";
import { buildSchemas, webPageSchema, breadcrumbSchema } from "../seo/schemas";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export default function Projects() {
  return (
    <SiteLayout>
      <Seo
        title="Projects — Manuel Santana's Ecosystem"
        description="The wider ecosystem of Manuel Santana — The Prove Your Point Podcast, Meet to Keep and The 12 Laws of Dating Dynamics."
        path="/projects"
        schemas={buildSchemas([
          webPageSchema({ path: "/projects", name: "Manuel Santana — Projects", description: "Ecosystem of Manuel Santana's media, dating, wellness and publishing projects." }),
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Projects", path: "/projects" }]),
        ])}
      />
      <PageHeader
        overline="Projects — Ecosystem"
        title="What Manuel"
        italic="builds off-mic."
        kicker="Beyond the podcast and the books — the studios, communities and brands operating in his orbit. Each is secondary to Manuel Santana the personal brand, but each does real work."
      />

      <section data-testid={PROJECTS_T.section} className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12 space-y-24">
          {PROJECTS.map((p, idx) => {
            const slug = slugify(p.name);
            const external = p.href.startsWith("http");
            return (
              <article
                key={p.name}
                id={slug}
                data-testid={PROJECTS_T.card(slug)}
                className="grid grid-cols-12 gap-6 lg:gap-16 items-start border-t border-black/10 pt-12"
              >
                <div className="col-span-12 md:col-span-3">
                  <p className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[#C8102E]">№ 0{idx + 1}</p>
                  <p className="mt-3 font-mono-ui text-[11px] tracking-[0.2em] uppercase text-[#0a0a0a]">{p.role}</p>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <h2 className="font-display text-[#0a0a0a] text-[clamp(32px,5vw,60px)] leading-[1.02] tracking-[-0.02em]">{p.name}</h2>
                  <p className="mt-6 text-black/70 text-base md:text-lg leading-relaxed max-w-2xl">{p.summary}</p>
                  {external && (
                    <p className="mt-4 font-mono-ui text-[11px] tracking-[0.2em] uppercase text-[#C8102E]">
                      {p.href.replace(/^https?:\/\//, "")}
                    </p>
                  )}
                </div>
                <div className="col-span-12 md:col-span-3 md:text-right">
                  {external ? (
                    <a href={p.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-black/30 hover:bg-[#C8102E] hover:text-white hover:border-[#C8102E] px-5 py-3 font-mono-ui text-[11px] tracking-[0.2em] uppercase transition-all">
                      {p.cta} <ArrowUpRight size={14} />
                    </a>
                  ) : (
                    <Link to={p.href} className="inline-flex items-center gap-2 border border-black/30 hover:bg-[#0a0a0a] hover:text-white px-5 py-3 font-mono-ui text-[11px] tracking-[0.2em] uppercase transition-all">
                      {p.cta} <ArrowUpRight size={14} />
                    </Link>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </SiteLayout>
  );
}
